import MenuButton from '../MenuButton.jsx'
import useMenuItemExportSpec from './useMenuItemExportSpec.jsx'

export default function MenuButtonExportSpec(props) {
    const items = [
        useMenuItemExportSpec(1),
        useMenuItemExportSpec(2),
        useMenuItemExportSpec(3),
    ]

    return (
        <MenuButton
            items={items}
            {...props}
        >
            导出Spec
        </MenuButton>
    )
}
